import { display } from "redux-react/reducers/snackBarReducer";
import { api } from "./api";

const actions = {
	/* Copy dictionary */
	copyDictionary: (code, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/dictionaries/copy/${code}`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Get one dictionary by code */
	getDictionary: (code, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/dictionaries/code/${code}`,
					onSuccess,
					onFailure: err => {
						/* dispatch(
							display({
								type: "error",
								message: err.response?.data?.error ?? "An error occurred"
							})
						); */
						onFailure(err);
					}
				})
			);
		};
	},
	/* Get dictionaries mappings */
	getDictionariesMappings: (assistantID = null, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/dictionaries/mappings?assistantID=${assistantID}`,
					onSuccess,
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error ?? "none"
							})
						);
						onFailure(err);
					}
				})
			);
		};
	},
	/* Get all dictionaries */
	getDictionaries: (assistantID = null, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/dictionaries?assistantID=${assistantID}`,
					onSuccess,
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error ?? "none"
							})
						);
						onFailure(err);
					}
				})
			);
		};
	},
	insertDictionary: (accountID, data, onSuccess, onFailure) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/dictionary/${accountID}`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	updateDictionary: (code, update, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/api/v1/dictionary/${code}`,
					data: update,
					onSuccess,
					onFailure
				})
			);
		};
	},
	getSettings: (type, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/settings/${type}`,
					onSuccess,
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error?.message ?? "An error occurred"
							})
						);
					}
				})
			);
		};
	},
	newSetting: (category, data, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/settings/${category}`,
					data,
					onSuccess,
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error?.message ?? "none"
							})
						);
					}
				})
			);
		};
	},
	editSetting: (category, data, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/api/v1/settings/${category}`,
					data,
					onSuccess,
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error?.message ?? "none"
							})
						);
					}
				})
			);
		};
	},
	deleteSetting: (category, query, onSuccess, catalog = null) => {
		let data = {
			query,
			catalog
		};
		return dispatch => {
			dispatch(
				api({
					method: "DELETE",
					url: `/api/v1/settings/${category}`,
					data,
					onSuccess,
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error?.message ?? "none"
							})
						);
					}
				})
			);
		};
	},
	reorderPage: (datas, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/settings/page/${datas.from}/${datas.to}`,
					onSuccess,
					data: {},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error?.message ?? "none"
							})
						);
					}
				})
			);
		};
	},
	createDictionaryChart: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/settings/createDictionaryChart`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	migrateFAIQ: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/faiq/migrate`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	deleteFAIQ: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/faiq/delete`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	copyFaiq: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/faiq/copy`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	getRuntimes(data, onSuccess, onFailure = () => {}) {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/faiq/runtimes`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	}
};

export default actions;
